import { enums } from "@shared/constants";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { useCallback, useRef } from "react";
import FormControl from "@ui-kit/form/FormControl/FormControl.web";
import CustomPriceInput from "../CustomPriceInput/CustomPriceInput.web";
import {
  CustomPriceFormDataType,
  CustomPriceInputRef,
} from "../CustomPriceInput/CustomPriceInput.props";
import CustomPriceOptions from "../CustomPriceOptions/CustomPriceOptions.web";
import { CustomPriceSelectionProps } from "./CustomPriceSelection.props";

const CustomPriceSelection = (props: CustomPriceSelectionProps) => {
  const {
    defaultPrice,
    options = [],
    currency = enums.CURRENCY_MAP.CAD.id,
    minPrice,
    onSetPrice,
    price,
    isFreeAllowed,
  } = props;

  /** ref for storing form reset method */
  const customPriceInputRef = useRef<CustomPriceInputRef>(null);

  /** if item in the basket has custom price, and it is not the option from the list */
  const isCustomOption =
    price !== null &&
    price !== undefined &&
    !options?.includes(price) &&
    price !== defaultPrice;

  const handleOptionChange = useCallback(
    (value: string) => {
      /** if custom price has validation error, reset it on option selection */
      customPriceInputRef.current?.resetFormErrors();

      /** if price is default, request should have null as value */
      const newPrice = value === defaultPrice ? null : value;
      onSetPrice?.(newPrice);
    },
    [defaultPrice, onSetPrice, customPriceInputRef]
  );

  const handleSave = useCallback(
    (data: CustomPriceFormDataType) => {
      onSetPrice?.(data.price);
    },
    [onSetPrice]
  );

  /** if custom price then any option should be selected by default  */
  const defaultOption = isCustomOption ? undefined : price ?? defaultPrice;

  return (
    <FormControl width={{ base: "100%" }}>
      <Flex justifyContent="space-between" flexWrap="wrap" gap="2xs">
        <CustomPriceSelection.Options
          price={price}
          options={[defaultPrice, ...options]}
          defaultOption={defaultOption}
          onChange={handleOptionChange}
          currency={currency}
          isCustomOption={isCustomOption}
        />

        <CustomPriceSelection.Input
          onSave={handleSave}
          minPrice={minPrice}
          price={isCustomOption ? price : ""}
          isFreeAllowed={isFreeAllowed}
          currency={currency}
          innerRef={customPriceInputRef}
        />
      </Flex>
    </FormControl>
  );
};

CustomPriceSelection.Options = CustomPriceOptions;
CustomPriceSelection.Input = CustomPriceInput;

export default CustomPriceSelection;
